<template>
  <a-drawer
    :visible="visible"
    :title="title"
    width="60%"
    destroyOnClose
    @close="onClose"
  >
    <div>
      <a-form-model
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="form"
      >
        <a-form-model-item label="角色名称">
          <a-input
            v-model="form.roleName"
            placeholder="请输入角色名称"
            @change="nameChange"
          />
        </a-form-model-item>
        <a-form-model-item label="角色别名">
          <a-input v-model="form.roleKey" placeholder="请输入角色别名" />
        </a-form-model-item>
        <a-form-model-item label="角色状态">
          <a-switch size="small" default-checked v-model="form.isStatus" />
        </a-form-model-item>
        <a-form-model-item label="菜单权限">
          <a-tree
            v-model="form.menuIds"
            checkable
            :tree-data="treeData"
            @expand="onExpand"
            @select="onSelect"
            :defaultExpandAll="true"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="footer-but">
        <a-button style="margin-right: 8px" @click="onClose"> 取消 </a-button>
        <a-button class="first-but" type="primary" @click="handleOk">
          确定
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { getMenu, roleList, addRole, editRole } from '@/api/role'
import pinyin from 'js-pinyin'
export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: String,
    rows: Object
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        roleName: '',
        isStatus: true,
        roleKey: '',
        roleSort: '1',
        menuIds: [],
      },
      menuList: [],
      treeData: [],
      expandedKeys: [],
      autoExpandParent: true,
      selectedKeys: [],
      roleList: [],
    }
  },
  watch: {
    rows (val) {
      if (val && this.visible) {
        this.init(val)
        
      }
    },
    visible (val) {
      if (val) {
        this.getMenuList()
        this.init(this.rows)
        // this.getRoleList()
      }
    }
  },
  mounted () {

  },
  methods: {
    init(val){
       this.form.roleId = val.roleId
        this.form.roleName = val.roleName
        this.form.roleKey = val.roleKey
        this.form.menuIds = val.menuIds
        val.status = String(val.status)
        if (val.status === '0') {
          this.form.isStatus = true
        } else {
          this.form.isStatus = false
        }
    },
    nameChange () {
      pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
      if (this.form.roleName !== '') {
        this.form.roleKey = this.form.roleName + '-' + pinyin.getCamelChars(this.form.roleName).toLowerCase()
      } else {
        this.form.roleKey = ''
      }
    },
    async getRoleList () {
      let res = await roleList()
      this.roleList = res.data
    },
    async handleOk () {
      this.form.roleSort = '1'
      if (this.form.isStatus) {
        this.form.status = 0
      } else {
        this.form.status = 1
      }
      if (this.form.roleName === '') {
        this.$message.warning('角色名称不能为空!')
      } else if (this.form.roleKey === '') {
        this.$message.warning('角色别名不能为空!')
      } else if (this.form.menuIds === null || this.form.menuIds.length === 0) {
        this.$message.warning('请选择菜单权限!')
      } else {
        if (this.title === '新增') {
          let res = await addRole(this.form)
          this.commonRole(res)
        } else {
          let res = await editRole(this.form)
          this.commonRole(res)
        }
      }

    },
    async commonRole (res) {
      if (res.code === 200) {
        this.$message.success(this.title + '成功!')
        this.$emit('updateList')
        this.reset()
        this.$emit('ok')
      } else {
        this.$message.warning(res.msg)
      }
    },
    editRole () {

    },
    onClose () {
      this.reset()
      this.$emit('ok')
    },
    // 重置
    reset () {
      Object.keys(this.form).forEach(i => {
        if (Array.isArray(this.form[i])) {
          this.form[i] = []
        } else {
          this.form[i] = ''
        }
      })
    },
    getData () { },
    getMenuList () {
      getMenu().then(res => {
        res.data.forEach(item => {
          this.common(item)
        })
        this.treeData = res.data
      })
    },
    common (item) {
      item.key = item.id
      item.title = item.label
      if (item.children && item.children.length > 0) {
        this.filedChange(item.children)
      }
    },
    filedChange (val) {
      val.forEach(item => {
        this.common(item)
      })
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelect (selectedKeys) {
      this.selectedKeys = selectedKeys;
    },
  }
}
</script>

<style>
</style>